











































































import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '../../store'
import { TableColumnItemType, OperationItemType } from '../../types/type'
import { Pagination } from '../../mixins/pagination'
@Component({
  name: 'RoleJurisdiction',
  mixins: [Pagination],
  components: {
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../components/common/tableModule.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class RoleJurisdiction extends Vue {
  public tableDataList: any[] = []
  public currentPage: number = 1
  public pageSize: number = 10
  public total: number = 0
  public loading: boolean = false
  public dialogVisible: boolean = false
  public title: string = ''
  public whoEditorId: number | string = ''
  public isOnlyLook: boolean = false
  public descr: string = ''
  public name: string = ''
  public allAuthorityList: any[] = []
  public defaultProps: any = {
    children: 'children',
    label: 'name'
  }
  // 列表列：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '角色名称',
      key: 'name',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '角色描述',
      key: 'descr',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    }
  ]
  // 列操作：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '编辑',
      key: 'update',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '权限分配',
      key: 'roleDistribution',
      type: 'warning',
      size: 'mini'
    },
    {
      title: '删除',
      key: 'delete',
      type: 'danger',
      size: 'mini'
    }
  ]
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-circle-plus-outline m_r5'></span>新增角色",
      key: 'add',
      type: 'primary',
      size: ''
    }
  ]

  operationForButton ({ key }, row) {
    switch (key) {
      case 'add':
        this.addOneRole()
        break
      case 'detail':
        this.goDetail(row)
        break
      case 'update':
        this.editorDetail(row)
        break
      case 'roleDistribution':
        this.roleDistribution(row)
        break
      case 'delete':
        this.deleteOfOne(row)
        break
    }
  }

  get userInfoAuthority () {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    let _that: any = this
    return _that.$RoleCode
  }

  async deleteOfOne (item: any) {
    try {
      this.$confirm('确定要删除此角色吗?', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消删除',
        type: 'error'
      })
        .then(async () => {
          let _that: any = this
          let params = {
            roleId: item.id
          }
          let { data: result } = await _that.$http.deleteRole(params)
          if (result.code !== 200) return this.$message.error(result.msg)
          this.$message.success('删除成功')
          this.getTableDataList()
        })
        .catch(() => {})
    } catch (err) {
      console.log(err)
    }
  }

  goDetail (item: any) {
    this.title = '角色详情'
    this.descr = item.descr
    this.name = item.name
    this.whoEditorId = item.id
    this.isOnlyLook = true
    this.dialogVisible = true
  }

  addOneRole () {
    this.title = '新增角色'
    this.whoEditorId = this.name = this.descr = ''
    this.isOnlyLook = false
    this.dialogVisible = true
  }

  async editorDetail (item: any) {
    try {
      this.title = '编辑角色'
      this.descr = item.descr
      this.name = item.name
      this.whoEditorId = item.id
      this.isOnlyLook = false
      this.dialogVisible = true
    } catch (err) {
      console.log(err)
    }
  }

  async save () {
    try {
      let _that: any = this
      let params = {
        name: this.name,
        descr: this.descr
      }
      let messageText: string = '新增成功'
      if (this.whoEditorId) {
        messageText = '编辑成功'
        Object.assign(params, { id: this.whoEditorId })
      }
      var { data: result } = await _that.$http.saveOrUpdateOfRole(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.dialogVisible = false
      this.getTableDataList()
    } catch (err) {
      console.log(err)
    }
  }

  roleDistribution (item: any) {
    this.$router.push({ name: 'RoleDistribution', query: { id: item.id } })
  }

  handleSizeChange (pageSize: number): void {
    this.pageSize = pageSize
    this.getTableDataList()
  }

  handleCurrentChange (currentPage: number): void {
    this.currentPage = currentPage
    this.getTableDataList()
  }

  async getTableDataList () {
    try {
      let _that: any = this
      this.loading = true
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      let { data: result } = await _that.$http.getRoleList(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.tableDataList = (result.data && result.data.records) || []
      this.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  async getAllAuthority () {
    try {
      let _that: any = this
      let { data: result } = await _that.$http.getAllAuthority()
      if (result.code !== 200) return this.$message.error(result.msg)
      this.allAuthorityList = JSON.parse(
        JSON.stringify(result.data).replace(/descr/g, 'name')
      )
    } catch (err) {
      console.log(err)
    }
  }

  defaultCheckList (MenusViewList, scope) {
    // let _that: any = this;
    //     let params = {
    //         roleId: scope.row.id
    //     };
    //     let {data: result} = await _that.$http.getRoleAuthoritys(params);
    //     if (result.code !== 200) return this.$message.error(result.msg);
    //     console.log(result);
    // return [];
    // this.defaultCheckedList = this.childList = result.data.map(item => item.code);
    // return typeof scope.row.menus_view === 'string'? scope.row.menus_view.split(','): [];
  }

  created () {
    this.getTableDataList()
    this.getAllAuthority()
  }
}
